import Config from '@/config';

export function isThemeEditorPreview(): boolean
{
	return Config.FEATURE_THEME_EDITOR_ENABLED && location.hostname.split('.')[0] === Config.THEME_EDITOR_SUBDOMAIN;
}
